var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.5 1a1 1 0 0 1 1.414 0l7 7-7 7A1 1 0 0 1 5.5 13.586L11.086 8 5.5 2.414A1 1 0 0 1 5.5 1z","fill":"#fff"}));
}

ArrowRight.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
